import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var typographies = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle', 'body1', 'body', 'button', 'caption', 'captionMedium', 'badges', 'overline'];
export default (function (theme) {
  return _objectSpread(_objectSpread({
    root: {
      display: 'inline-block',
      cursor: 'pointer !important',
      padding: 0,
      color: theme.colors.blue500,
      transition: 'color .1s ease-in-out',
      border: 'none',
      outline: 'none',
      background: 'transparent',
      textDecoration: 'none',
      '&:hover': {
        color: theme.colors.blue600
      },
      '& *': {
        cursor: 'pointer'
      }
    },
    isDisabled: {
      opacity: 0.5,
      cursor: 'not-allowed !important',
      '&:hover': {
        backgroundPosition: '0 0 !important'
      },
      '& *': {
        cursor: 'not-allowed'
      }
    }
  }, typographies.reduce(function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, _objectSpread({}, theme.typography[key])));
  }, {})), {}, {
    bold: {
      fontWeight: 500
    },
    truncated: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inherit'
    },
    underline: {
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    primary: {
      color: theme.colors.orange500,
      '&:hover': {
        color: theme.colors.orange600
      }
    }
  });
});